import CaseInfo from "./case-info";
import "./case-info-list.sass";

type Props = {
  stats: {
    id: string;
    bgColor?: "green-bg" | "blue-bg" | "light-blue-bg" | string;
    textColor?: "white" | "blue";
    value: string | number;
    description: string;
    color?: { hex: string };
    number: string | number;
  }[];
};
const CaseInfoList = ({ stats }: Props) => {
  return (
    <div className="case-info-list">
      {stats.map((stat) => (
        <CaseInfo
          key={stat.id}
          bgColor={stat.color && stat.color.hex ? stat.color.hex : "#115EF3"}
          textColor="white"
          text={stat.description}
          value={stat.number}
          isRow={true}
          textSize="24px"
        />
      ))}
    </div>
  );
};

export default CaseInfoList;
